/**
 * Country Images V2 — SEO-friendly image loader
 *
 * URL format: https://img.gstarlink.com/{country}-prepaid-travel-esim-{product_id}.jpg
 *
 * Example: https://img.gstarlink.com/japan-prepaid-travel-esim-8847201.jpg
 */
(function () {
  'use strict';

  var IMG_BASE = 'https://img.gstarlink.com';
  var FALLBACK = 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=600&h=375&fit=crop&q=80';

  var COUNTRY_SLUGS = {
    'japan': 'japan',
    'france': 'france',
    'united states': 'united-states', 'usa': 'united-states', 'america': 'united-states',
    'thailand': 'thailand',
    'south korea': 'south-korea', 'korea': 'south-korea',
    'indonesia': 'indonesia',
    'vietnam': 'vietnam',
    'australia': 'australia',
    'united kingdom': 'united-kingdom', 'uk': 'united-kingdom', 'britain': 'united-kingdom',
    'china': 'china',
    'turkey': 'turkey',
    'singapore': 'singapore',
    'taiwan': 'taiwan',
    'new zealand': 'new-zealand',
    'india': 'india',
    'morocco': 'morocco',
    'spain': 'spain',
    'germany': 'germany',
    'italy': 'italy',
    'canada': 'canada',
    'malaysia': 'malaysia',
    'philippines': 'philippines',
    'hong kong': 'hong-kong',
    'europe': 'europe',
    'asia': 'asia',
  };

  function normalizeCountry(raw) {
    if (!raw) return 'global';
    var lower = raw.toLowerCase().trim();
    return COUNTRY_SLUGS[lower] || lower.replace(/\s+/g, '-');
  }

  function buildUrl(country, productId) {
    // https://img.gstarlink.com/japan-prepaid-travel-esim-8847201.jpg
    return IMG_BASE + '/' + country + '-prepaid-travel-esim-' + productId + '.jpg';
  }

  function loadImages() {
    var imgs = document.querySelectorAll('.gstarlink-img[data-country][data-product-id]');
    if (!imgs.length) return;

    imgs.forEach(function (img) {
      var country = normalizeCountry(img.getAttribute('data-country'));
      var productId = img.getAttribute('data-product-id');

      if (!productId) {
        img.src = FALLBACK;
        return;
      }

      img.src = buildUrl(country, productId);

      img.onerror = function () {
        if (img.src !== FALLBACK) {
          img.src = FALLBACK;
        }
      };
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadImages);
  } else {
    loadImages();
  }
})();
